var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9785 14.122L14.4785 3.62198C14.0585 3.20198 13.4752 2.94531 12.8335 2.94531H4.66683C3.3835 2.94531 2.3335 3.99531 2.3335 5.27865V13.4453C2.3335 14.087 2.59016 14.6703 3.02183 15.102L13.5218 25.602C13.9418 26.022 14.5252 26.2786 15.1668 26.2786C15.8085 26.2786 16.3918 26.022 16.8118 25.5903L24.9785 17.4236C25.4102 17.0036 25.6668 16.4203 25.6668 15.7786C25.6668 15.137 25.3985 14.542 24.9785 14.122ZM15.1668 23.957L4.66683 13.4453V5.27865H12.8335V5.26698L23.3335 15.767L15.1668 23.957ZM5.8335 8.19531C5.8335 7.22881 6.617 6.44531 7.5835 6.44531C8.54999 6.44531 9.3335 7.22881 9.3335 8.19531C9.3335 9.16181 8.54999 9.94531 7.5835 9.94531C6.617 9.94531 5.8335 9.16181 5.8335 8.19531Z",
    fill: "#A6E1FA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.c77e3728609715c065789b1e69278f54.svg";
export { ForwardRef as ReactComponent };